import accounting from "accounting-js";

export const methodMixin = {
  methods: {
    formatCurrency: function (amount, decimals = 2){
      let localised = 0;

      if (amount) {
        switch (this.$store.getters.GetActiveLanguage) {
          case "br":
            localised = parseFloat(amount).toLocaleString('pt-BR', {maximumFractionDigits: decimals, minimumFractionDigits: decimals});
            break
          default:
            localised = parseFloat(amount).toLocaleString('en-US', {maximumFractionDigits: decimals, minimumFractionDigits: decimals});
            break
        }
      }

      return localised
    },
    currencyFormat: function (amount, decimals = 2) {
      let cleanAmount = 0;
      let localised = 0;

      if (amount) {
        switch (this.$store.getters.GetActiveLanguage) {
          case "br":
            cleanAmount = parseFloat(amount.toString().replace(/\./g, '').replace(',', '.')).toFixed(decimals)
            localised = parseFloat(cleanAmount).toLocaleString('pt-BR', {maximumFractionDigits: decimals, minimumFractionDigits: decimals});
            break
          default:
            cleanAmount = parseFloat(amount.toString().replace(/\,/g, '')).toFixed(decimals)
            localised = parseFloat(cleanAmount).toLocaleString('en-US', {maximumFractionDigits: decimals, minimumFractionDigits: decimals});
            break
        }
      }

      return [cleanAmount, localised]
    },
    async fileProcess(fileList) {

      const imageData = await this._getFile(fileList[0])

      if (imageData.type.includes('image')) {
        const newImage = await this._imageResize(imageData.data)
        imageData.data = newImage
        imageData.size = newImage.length
      } else {
        imageData.size = imageData.original_size
      }
      return imageData
    },
    _getFile: function (file) {

      const reader = (file) => {
        return new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.onload = () => resolve(fileReader.result);
          fileReader.readAsDataURL(file);
        });
      };

      const readFile = (file) => {
        return reader(file).then(
          result => {
            return {
              name: file.name.replaceAll(' ', '_').toLowerCase(),
              type: file.type,
              data: result,
              original_size: file.size,
            };
          }
        );
      };

      return readFile(file);
    },
    _imageResize: function (image) {

      const processImage = (file) => {
        return new Promise((resolve, reject) => {

          const img = new Image();

          img.onload = () => {

            let canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            canvas.getContext('2d').drawImage(img, 0, 0);

            let MAX_WIDTH = 1500;
            let MAX_HEIGHT = 1000;
            let width = img.width;
            let height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }

            canvas.width = width;
            canvas.height = height;

            let ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            resolve(canvas.toDataURL('image/jpeg', 0.7))
          };

          img.src = file;
        });
      };

      return processImage(image);
    },
    format_cpf_cnpj_test: function (value) {
      if (value) {
        if (value.length === 14) {
          return value.replace(/(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})/, '$1.$2.$3/$4-$5');
        } else {
          return value.replace(/(\w{3})(\w{3})(\w{3})(\w{2})/, '$1.$2.$3-$4');
        }
      }
    },
    fill_branch_dropdown: function (bank_code) {
      this.$store.dispatch('SetBranchDropDown', null);
      const response = this.backend_request('/api/data/bank/branches/' + bank_code, {}, 'get');
      response.then(response => {
        this.$store.dispatch('SetBranchDropDown', response.data.data);
        return this.$store.getters.GetBranchDropDown;
      }).catch(function (error) {
        console.error(error);
      });
    },
    money_format: function (value) {

      const intVal = (i) => {
        return typeof i === 'string' ? i.replace(/[$,]/g, '') * 1 : typeof i === 'number' ? i : 0;
      };

      value = intVal(value)

      // return accounting.formatNumber(value, {
      //   symbol: "R$",
      //   thousand: ".",
      //   decimal: ",",
      //   format: "%s %v"
      // });

      return accounting.formatNumber(value, 2, "");
    },
    money_unFormat: function (value) {
      // console.log(value);
      // console.log(value.replace(",","").replace(".",""));
      return accounting.unformat(value);
    },
    backend_request: function (url, data, type) {

      data.language = this.$store.getters.GetActiveLanguage;

      let api_url = 'https://api-develop.easyremessa.com' + url.replace("api", "web-api");
      // let api_url = 'http://localhost:3000' + url.replace("api", "web-api");

      if (this.$store.getters.GetConfig.ENVIRONMENT !== 'local') {
        api_url = this.$store.getters.GetConfig.API + url.replace("api", "web-api");
      }

      let config = {
        headers: {
          "Content-Type": "application/json"
        }
      };

      if (type === 'post') {
        return this.$http
          .post(
            api_url,
            data,
            config
          )
      } else {
        return this.$http
          .get(
            api_url,
            config
          )
      }

    },
  },
  computed: {
    country_dropdown() {
      return this.$store.getters.GetCountryDropDown;
    },
    account_type_dropdown() {
      return this.$store.getters.GetAccountTypeDropDown;
    },
    bank_dropdown() {
      if (!this.$store.getters.GetBankDropDown) {
        const response = this.backend_request('/api/data/banks', {}, 'get');
        response.then(response => {
          this.$store.dispatch('SetBankDropDown', response.data.data);
          return this.$store.getters.GetBankDropDown;
        }).catch(function (error) {
          console.error(error);
        });
      } else {
        return this.$store.getters.GetBankDropDown;
      }
    },
    branch_dropdown() {
      return this.$store.getters.GetBranchDropDown || [];
    }
  }
};
